import { AdditionServicesOptionsState } from '@pages/AdditionalServices/containers/additionServicesOptionsContext';
import {
  AServiceCache,
  AServicePropertyCache,
  AServicePropertyFilterAndOrder,
  AdditionServicesState,
} from '@pages/AdditionalServices/containers/types';

import { ServiceData, SetUpServiceData } from '../../../basket/types';
import { calculateFieldValues } from '../../../calculateFieldValues';
import { serviceRestoreStateGeneratorProcessor } from '../types';

/**
 * SetUpGlobalFieldsProcessor формирует и восстанавливает значения полей виджета на основе установочной услуги.
 * Устанавлиает восстановленное значение только если оно не скрыто и не пренадлежит к ограничениям.
 */
export class SetUpGlobalFieldsProcessor implements serviceRestoreStateGeneratorProcessor {
  /**
   * restore выполняет восстановление стейтов. Возвращает все стейты.
   * @param setUpServiceData
   * @param __
   * @param additionalServiceState
   * @param optionsState
   * @param serviceCacheState
   * @param servicePropertyCacheState
   * @param servicePropertyFilterAndOrderState
   */
  async restore(
    setUpServiceData: SetUpServiceData,
    __: (SetUpServiceData | ServiceData)[],
    additionalServiceState: AdditionServicesState,
    optionsState: AdditionServicesOptionsState,
    serviceCacheState: AServiceCache,
    servicePropertyCacheState: AServicePropertyCache,
    servicePropertyFilterAndOrderState: AServicePropertyFilterAndOrder
  ) {
    let isSomeValueChanged = false;

    const setUpFieldValues: { [T in string]: number } = {};
    const setUpFieldList = additionalServiceState.FieldsToDisplay.map((field) => {
      const setUpValue = setUpServiceData.FieldValues[field.code];
      const currentValue = additionalServiceState.FieldValues[field.code];

      if (setUpValue !== currentValue) {
        isSomeValueChanged = true;
      }

      if (field.type === 'hidden' || field.settings.DefaultSettings.IsNeedDisplayOnlyTextInfo) {
        setUpFieldValues[field.code] = currentValue;
        return { ...field, value: currentValue };
      }

      if (
        !!setUpValue &&
        field.handbook_limitations.length > 0 &&
        !field.handbook_limitations.includes(setUpValue.toString())
      ) {
        setUpFieldValues[field.code] = currentValue;
        return { ...field, value: currentValue };
      }
      setUpFieldValues[field.code] = setUpValue ?? currentValue;
      return { ...field, value: setUpValue ?? currentValue };
    });

    return {
      isValid: true,
      additionalServiceState: {
        ...additionalServiceState,
        FieldsToDisplay: setUpFieldList,
        FieldValues: isSomeValueChanged
          ? calculateFieldValues(setUpFieldList, setUpFieldValues, {})
          : setUpFieldValues,
      },
      optionsState,
      serviceCacheState,
      servicePropertyCacheState,
      servicePropertyFilterAndOrderState,
    };
  }
}
